module.exports = __webpack_public_path__ + "3a14da9246fee378f56a8d074c7adab9.png";